/**
 * Shopify Popup JS - Stable Production & Preview Version
 * * 修正ポイント:
 * 1. ポップアップが「開いていない」状態でのリダイレクトを完全に遮断。
 * 2. Shopifyプレビュー/エディタ環境での履歴操作を無効化しループを防止。
 * 3. ページロード直後のpopstateイベント（プレビュー環境のバグ）を無視。
 */

(function($) {
    // --- 設定 ---
    const CONFIG = {
        imgSrc: "https://cdn.shopify.com/s/files/1/0891/1657/4065/files/popup.png?v=1759133351",
        couponUrl: "/pages/coupon",
        debug: true
    };

    // --- 状態管理 ---
    let state = {
        isOpen: false,
        isBackNavigation: false,
        loadTime: Date.now(),
        currentUrl: window.location.pathname
    };

    function debugLog(msg, data = null) {
        if (CONFIG.debug) console.log(`[Popup Debug] ${msg}`, data || "");
    }

    // --- 判定ロジック ---
    function isPreview() {
        return window.Shopify && (window.Shopify.designMode || window.location.search.includes('preview_theme_id'));
    }

    function isArticlePage() {
        if (window.shopifyTemplate && typeof window.shopifyTemplate.isArticle !== 'undefined') {
            return window.shopifyTemplate.isArticle;
        }
        const parts = window.location.pathname.split('/').filter(p => p);
        return parts[0] === 'blogs' && parts.length >= 3;
    }

    function getPreviousData() {
        try {
            const data = sessionStorage.getItem('popup_prev_page');
            return data ? JSON.parse(data) : null;
        } catch (e) { return null; }
    }

    // --- ポップアップ操作 ---
    function openPopup(type) {
        if (state.isOpen) return;

        // 表示判定
        let shouldShow = false;
        if (type === 'back') {
            const prev = getPreviousData();
            // 前のページが記事 かつ 今のURLと違う かつ 1分以内の遷移
            shouldShow = prev && prev.isArticle && prev.path !== window.location.pathname && (Date.now() - prev.time < 60000);
            state.isBackNavigation = true;
        } else {
            shouldShow = isArticlePage();
            state.isBackNavigation = false;
        }

        if (shouldShow) {
            debugLog(`Open Popup Triggered: ${type}`);
            $(".l_popUp, .l_popUpMask").fadeIn(400);
            $("html").css("overflow", "hidden");
            state.isOpen = true;
        }
    }

    function closePopup() {
        $(".l_popUp, .l_popUpMask").fadeOut(400);
        $("html").css("overflow", "unset");
        state.isOpen = false;
        debugLog("Popup Closed");
    }

    // --- 初期化 ---
    function init() {
        // 画像とリンクのセット
        $("#popUp_img").attr("src", CONFIG.imgSrc);
        $("#popup_link01").attr("href", "#");
        $("#popup_link02").attr("href", CONFIG.couponUrl);

        // ページ訪問の記録（今のページを「前回のページ」として保存する準備）
        const currentData = {
            isArticle: isArticlePage(),
            path: window.location.pathname,
            time: Date.now()
        };
        
        // ページを離れる時に保存
        $(window).on('pagehide beforeunload', function() {
            sessionStorage.setItem('popup_prev_page', JSON.stringify(currentData));
        });

        // 履歴操作のセットアップ（記事ページかつ本番環境のみ）
        if (isArticlePage() && !isPreview() && window.history && window.history.pushState) {
            if (!window.history.state || window.history.state.popup !== 'active') {
                window.history.pushState({ popup: 'active' }, null, window.location.href);
                debugLog("History state pushed (Article Page)");
            }
        }

        // --- イベントリスナー ---

        // 1. 戻るボタン検知 (popstate)
        window.addEventListener("popstate", function(e) {
            // プレビュー環境の誤作動（ロード直後の発火）を無視
            if (Date.now() - state.loadTime < 800) {
                debugLog("Popstate ignored (too early)");
                return;
            }
            if (!state.isOpen) openPopup('back');
        });

        // 2. クローズボタン / マスク
        $(".p_popUp_close, .l_popUpMask").on("click", closePopup);

        // 3. ボタン1 (クーポンを受け取らない = 戻る)
        $("#popup_link01").on("click", function(e) {
            e.preventDefault();
            if (!state.isOpen) return; // 開いていない時は無視

            debugLog("Link01 clicked: Decline");
            closePopup();

            // ブラウザバックで開いた場合は、単に閉じるだけ（履歴はすでに一個戻っているため）
            if (state.isBackNavigation) {
                debugLog("Back navigation mode: Just closing.");
                return;
            }

            // 通常トリガー（タイマー等）で開いた場合は、一覧に戻す
            setTimeout(() => {
                debugLog("Normal mode: Redirecting to referrer.");
                if (document.referrer && document.referrer.includes(window.location.hostname)) {
                    window.location.href = document.referrer;
                } else {
                    window.history.back();
                }
            }, 100);
        });

        // 4. ボタン2 (クーポンを受け取る)
        $("#popup_link02").on("click", function(e) {
            e.preventDefault();
            if (!state.isOpen) return;
            closePopup();
            setTimeout(() => { window.location.href = CONFIG.couponUrl; }, 100);
        });

        // 5. タイマー表示
        setTimeout(() => {
            if (isArticlePage() && !state.isOpen) openPopup('timer');
        }, 10000);

        // 6. スクロール表示
        $(window).on("scroll.popup", function() {
            if (!isArticlePage() || state.isOpen) return;
            const scrollPos = $(window).scrollTop() + $(window).height();
            const docHeight = $(document).height();
            if (scrollPos >= docHeight - 100) {
                openPopup('scroll');
                $(window).off("scroll.popup");
            }
        });
    }

    // 実行
    $(document).ready(init);

})(jQuery);